import * as R from "ramda";

export const isNumber = (value: any): value is number => R.is(Number, value);
export const isString = (value: any): value is string => R.is(String, value);
